import React from 'react';
import NumberFormat from "react-number-format";

const CurrencyNumberFormatter = (props) => {
    const { inputRef, ...other } = props;

    return (
        <NumberFormat
            {...other}
            thousandSeparator
            decimalSeparator="."
            decimalScale={2}
            fixedDecimalScale
        />
    );
};

export default CurrencyNumberFormatter;